import React, { useState, useEffect, useRef, useCallback } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { QRCodeSVG } from 'qrcode.react';
import { isDesktop, APP_STORE_URL } from '../utils/platformDetect';
import { isDismissed, setDismissed, getSessionViewCount, trackEvent } from '../utils/promoTracking';
import { useLanguage } from '../contexts/LanguageContext';
import './AppPopup.css';

function AppPopup() {
  const [visible, setVisible] = useState(false);
  const overlayRef = useRef(null);
  const { t } = useLanguage();

  const handleClose = useCallback(() => {
    setVisible(false);
    setDismissed('app_popup', 7);
    trackEvent('app-popup-dismiss');
  }, []);

  useEffect(() => {
    if (!isDesktop() || isDismissed('app_popup', 7)) return;

    // Check if view count threshold is met
    if (getSessionViewCount() >= 3) {
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (!visible) return;

    const handleEsc = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [visible, handleClose]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) handleClose();
  };

  if (!visible) return null;

  return (
    <div
      className="app-popup-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-label={t('appPopupTitle')}
    >
      <div className="app-popup">
        <button className="popup-close" onClick={handleClose} aria-label="Close">
          <IoCloseOutline size={24} />
        </button>

        <div className="popup-grid">
          {/* Left - Phone screenshots */}
          <div className="popup-mockup">
            <div className="popup-screenshots">
              <div className="popup-screenshot-frame popup-screenshot-back">
                <img src="/app-screenshot-detail.png" alt="Station detail view" />
              </div>
              <div className="popup-screenshot-frame popup-screenshot-front">
                <img src="/app-screenshot-map.png" alt="Map view" />
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="popup-content">
            <h2>{t('appPopupTitle')}</h2>
            <p className="popup-desc">{t('appPopupDesc')}</p>

            <div className="popup-qr-section">
              <QRCodeSVG value={APP_STORE_URL} size={120} level="M" />
              <span className="popup-qr-label">{t('scanToDownload')}</span>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default AppPopup;
